<template>
    <div class="lang">
        <!-- 메인팝업 -->
        <div class="popup" :class="{ active: main_popup }" v-if="popupCnt > 0">
            <div class="main-popup">
                <h3 class="main-popup--title">
                    <img src="@/assets/resource/img/main/main-popup--title.png" alt="" />
                    <strong>POPUP ZONE</strong>
                </h3>
                <div class="main-popup__cont">
                    <p class="main-popup__cont--top">
                        팝업 전체 · <span>{{ popupCnt }}개</span>
                    </p>
                    <div class="swiper main-popup-swiper">
                        <ul class="swiper-wrapper main-popup__list">
                            <li class="main-popup__item swiper-slide" v-for="popup in popupList">
                                <a :href="popup.link" :target="popup.target">
                                    <img :src="`/displayFile.do?attachNo=${popup.attachBag.bannerImg[0].attachNo}`" :alt="popup.attachBag.bannerImg[0].altValue || '이미지'" v-if="popup.attachBag.bannerImg" />
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="main-popup-swiper__button-wrap">
                        <button class="main-popup-swiper__button prev"></button>
                        <button class="main-popup-swiper__button next"></button>
                    </div>
                </div>
                <div class="main-popup__button-wrap">
                    <a href="javascript:;" class="main-popup__button02" @click="closePopup">오늘 하루 열지 않기</a>
                    <a href="javascript:;" class="main-popup__button" @click.prevent="main_popup_close"></a>
                </div>
            </div>
        </div>

        <!-- 쳇봇팝업 -->
        <div class="popup popup-chetbot" :class="{ active: popup_chetbot }">
            <div class="popup__inner">
                <div class="popup__tit">
                    <h2>University Aortic Vascular Hospital a way to find</h2>
                    <button type="button" class="popup__close" @click="popup_chetbot_active"><img src="@/assets/resource/icon/close.svg" alt=""></button>
                </div>
                <div class="popup__body">
                    <div class="popup-chetbot__left">
                        <div class="popup-chetbot__left__top">
                            <div class="popup-chetbot__left__top__cont">
                                <h3 class="popup-chetbot__left--title">место отправления</h3>
                                <div class="select">
                                    <a href="javascript:;" class="select--btn" :class="{ active: chetbot_select }" @click.prevent="activechetbot_select">{{mapStartTxt}}</a>
                                    <slide-up-down :active="chetbot_select" class="select-option">
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('B1'), activechetbot_select()]">Выход 8 со станции Бальсан</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('main'), activechetbot_select()]">Главный вход в госпиталь (главные ворота)</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('north'), activechetbot_select()]">Дополнительный вход в госпиталь (северные ворота)</a>
                                        <a href="javascript:;" class="select-option--btn" @click="[setMapList('parking'), activechetbot_select()]">Подземная парковка B3-B5</a>
                                    </slide-up-down>
                                </div>
                            </div>
                            <div class="popup-chetbot__left__top__cont">
                                <h3 class="popup-chetbot__left--title">destination</h3>
                                <h4 class="title03">Ewha Womans University Aorta and Vascular Hospital </h4>
                            </div>
                        </div>
                        <div class="popup-chetbot__left__bottom">
                            <div class="popup-chetbot__left__bottom__cont">
                                <p v-html="mapList[mapIndex].start"></p>
                                <span class="arrow"></span>
                                <p v-html="mapList[mapIndex].end"></p>
                            </div>
                            <div class="popup-chetbot__btn-wrap">
                                <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 1}" @click="mapIndex = 0">Предыдущий путь</a>
                                <a href="javascript:;" :class="{'popup-chetbot__btn': true, 'active': mapIndex == 0}" @click="mapIndex = 1">Следующий путь</a>
                            </div>
                        </div>
                    </div>
                    <div class="popup-chetbot__right">
                        <div class="popup-chetbot__img">
                            <img :src="require(`@/assets/resource/img/main/${mapList[mapIndex].src}`)" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container main">
            <div id="custom-cursor">
                <img src="@/assets/resource/img/main/MORE+.png" alt="Custom Cursor" />
            </div>
            <section class="section section01 pin-spacer">
                <div class="main-visual">
                    <div class="main-visual-back">
                        <img src="@/assets/resource/img/main/section01_Vector.png" alt="" class="main-visual-back01" />
                        <img src="@/assets/resource/img/main/section01_gg01.png" alt="" class="main-visual-back02" />
                        <img src="@/assets/resource/img/main/section01_gg02.png" alt="" class="main-visual-back03" />
                        <img src="@/assets/resource/img/main/section01_gg03.png" alt="" class="main-visual-back04" />
                        <img src="" alt="" class="main-visual-back05" />
                    </div>
                    <div class="area">
                        <div class="main-visual__title">
                            <p>WORLD BEST</p>
                            <h3>Аортально-сосудистый госпиталь при университете Ихва</h3>
                            <div class="main-visual__scrolldown">
                                <p>SCROLL</p>
                                <img src="@/assets/resource/img/main/Arrow.png" alt="" />
                            </div>
                        </div>
                        <ul class="main-visual__list">
                            <li class="main-visual__list-type01">
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box01">
                                    <img src="@/assets/resource/img/main/main-visual__img01.png" alt="" />
                                    <h4>Функционирования системы ЭКСПРЕСС-диагностики 24 часа в сутки 365 дней в году</h4>
                                </a>
                            </li>
                            <li class="main-visual__list-type02">
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box02">
                                    <img src="@/assets/resource/img/main/main-visual__img02.png" alt="" />
                                    <h4>Быстрая доставка пациентов на вертолете в любое время и в любом месте</h4>
                                </a>
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box03">
                                    <img src="@/assets/resource/img/main/main-visual__img03.png" alt="" />
                                    <h4 class="blue">Гибридная операционная, в которой можно проводить операции 24 часа в сутки 365 дней в году</h4>
                                </a>
                            </li>
                            <!-- 가운데 메인 -->
                            <li class="main-visual__list-type03 visual gallery">
                                <span class="circle01"><img src="@/assets/resource/img/main/section01_circle.png" alt="" /></span>
                                <div class="imgBlockMain">
                                    <h3>
                                        창원파티마병원은 <br />
                                        끊임없이 학습합니다.
                                    </h3>
                                    <div class="video">
                                        <!-- 동영상 소스를 require()로 로드 -->
                                        <video id="myVideo" src="@/assets/resource/video/FullSizeRender.mp4" muted playsinline loop></video>
                                    </div>
                                    <div class="visual-main__wrap">
                                        <div class="visual-main_back"></div>
                                        <div class="visual-main inner">
                                            <h4>Приходите</h4>
                                            <h3 class="aa" style="font-family: 'Pretendard'">‘Мы спасем вас’</h3>
                                            <div class="visual-main__con">
                                                <ul class="visual-main__list">
                                                    <li class="visual-main__item">
                                                        <div class="visual-main__test">
                                                            <h4>Online Appointment</h4>
                                                            <p>
                                                                You can make a reservation and check your reservation easy and quick on-line.
                                                            </p>
                                                        </div>
                                                        <div class="visual-main__botton">
                                                            <div class="visual-main__buttom-wrap">
                                                                <a href="javascript:;" class="visual-main__buttom">Appointment</a>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="visual-main__item">
                                                        <div class="visual-main__test">
                                                            <h4>Location and Direction</h4>
                                                            <p>
                                                                How to get to and park at Hospital
                                                            </p>
                                                        </div>
                                                        <div class="visual-main__botton">
                                                            <div class="visual-main__buttom-wrap">
                                                                <a href="javascript:;" class="visual-main__buttom" @click.prevent="popup_chetbot_active">Direction</a>
                                                                <router-link to="/kr/mypage/reservation/selectReservation" class="visual-main__buttom">Parking Information</router-link>
                                                            </div>
                                                        </div>
                                                    </li>
                                                    <li class="visual-main__item">
                                                        <div class="visual-main__test">
                                                            <h4>Treatment Guide</h4>
                                                            <p>
                                                                Contact Number
                                                            </p>
                                                            <p class="num">+82-2-6986-3100 <br> <span>(Contact Hours : 08:00 ~ 17:00)</span></p>
                                                            <p>E-Mail : eumcint@gmail.com</p>
                                                        </div>
                                                    </li>

                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li class="main-visual__list-type02">
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box04">
                                    <img src="@/assets/resource/img/main/main-visual__img05.png" alt="" />
                                    <h4 class="blue">Специальное отделение для пациентов с аортальным поражением</h4>
                                </a>
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box05">
                                    <img src="@/assets/resource/img/main/main-visual__img06.jpg" alt="" />
                                    <h4>Открыт первый в мире центр реабилитации аорты!</h4>
                                </a>
                            </li>
                            <li class="main-visual__list-type01">
                                <a href="javascript:;" class="main-visual__list-box main-visual__list-box06">
                                    <img src="@/assets/resource/img/main/main-visual__img07.png" alt="" />
                                    <h4>Сестринское обслуживание во всех отделениях и комплексный уход за больными, не беспокоясь о семейном уходе</h4>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section class="section section02">
                <ul class="section02__backgroundtext">
                    <li>
                        <img src="@/assets/resource/img/main/section02__backgroundtext3.png" alt="" />
                    </li>
                    <li>
                        <img src="@/assets/resource/img/main/section02__backgroundtext4.png" alt="" />
                    </li>
                </ul>
                <div class="inner">
                    <div class="section02__background">
                        <img class="section02__background-ball1" src="@/assets/resource/img/main/section02__background-ball.png" alt="" />
                        <img class="section02__background-ball2" src="@/assets/resource/img/main/section02__background-ball2.png" alt="" />
                        <img class="section02__background-ball3" src="@/assets/resource/img/main/section02__background-ball3.png" alt="" />
                        <span class="section02__background-smollball no1"></span>
                        <span class="section02__background-smollball no2"></span>
                        <span class="section02__background-smollball no3"></span>
                        <span class="section02__background-smollball no4"></span>
                        <span class="section02__background-smollball no5"></span>
                        <span class="section02__background-smollball no6"></span>
                    </div>

                    <div class="section02_top_title transition01">
                        <h4>
                            Превосходный госпиталь № 1 первый в Корее Аортально-сосудистый <br> госпиталь при университете Ихва
                        </h4>
                    </div>
                    <div></div>
                    <div class="swiper section02-swiper">
                        <div class="section02__list transition02 swiper-wrapper">
                            <div :class="`section02__list--aa swiper-slide section02__list--item0${idx + 1}`" v-for="(doctor, idx) in doctorList">
                                <a href="javascript:;" :class="`section02__list--item cursor doctor0${idx + 1}`" :data-drsid="doctor.drSid" :data-deptcd="doctor.mainDeptCd">
                                    <div class="section02__list--item--img">
                                        <img :src="`/displayFile.do?attachNo=${doctor.attachBag.thumbs[0].attachNo}`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs" />
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="section02-swiper-button-wrap">
                            <button class="section02-swiper-button-next"></button>
                            <button class="section02-swiper-button-prev"></button>
                        </div>
                    </div>
                    <div class="swiper section02-swiper2">
                        <div class="section02_bottom_title transition02 swiper-wrapper">
                            <div :class="{ 'swiper-slide': true, on: idx == 2 }" v-for="(doctor, idx) in doctorList">
                                <h4>{{ doctor.name }} преподавание</h4>
                                <p>{{ doctor.detailField }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="section section03">
                <div class="swiper section03_list-back">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide section03_list-back--box">
                            <div class="section03_list-back--box_on">
                                <img src="@/assets/resource/img/main/section03-back1.jpg" alt="" />
                            </div>
                        </div>
                        <div class="swiper-slide section03_list-back--box">
                            <div class="section03_list-back--box_on">
                                <img src="@/assets/resource/img/main/section03-back2.jpg" alt="" />
                            </div>
                        </div>
                        <div class="swiper-slide section03_list-back--box">
                            <div class="section03_list-back--box_on">
                                <img src="@/assets/resource/img/main/section03-back3.jpg" alt="" />
                            </div>
                        </div>
                        <div class="swiper-slide section03_list-back--box">
                            <div class="section03_list-back--box_on">
                                <img src="@/assets/resource/img/main/section03-back4.png" alt="" />
                            </div>
                        </div>
                        <div class="swiper-slide section03_list-back--box">
                            <div class="section03_list-back--box_on">
                                <img src="@/assets/resource/img/main/section03-back5.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section__title transition01">
                    <h3>Знакомство с центрами</h3>
                    <p>На первом месте - центры первой аортальной и сосудистой больницы в стране.</p>
                </div>
                <div class="transition02">
                    <div class="swiper section03_list">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide section03_list--box">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_5-back.png" alt="" />
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_4-back.png" alt="" />
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_3-back.png" alt="" />
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_2-back.png" alt="" />
                                </div>
                            </div>
                            <div class="swiper-slide section03_list--box">
                                <div class="section03_list--box_on">
                                    <img src="@/assets/resource/img/main/section03_1-back.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="section03_list2_warp">
                        <div class="section03_list2-button">
                            <button class="section03_list2-button-prev">
                                <img src="@/assets/resource/img/main/section02-swiper-button-prev02.png" alt="" />
                            </button>
                            <button class="section03_list2-button-next">
                                <img src="@/assets/resource/img/main/section02-swiper-button-next02.png" alt="" />
                            </button>
                        </div>
                        <div class="swiper section03_list2">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=aor')">
                                    <div class="section03_list--box_on">
                                        <img src="@/assets/resource/img/main/section03_1.png" alt="" />
                                        <h4>Aorta Center</h4>
                                        <div class="text">
                                            <h3>Аортальный центр</h3>
                                            <p>
                                                В нашем теле много кровеносных сосудов, и среди них есть «аорта», которая «действует как магистраль». Поскольку аорта напрямую получает кровь от сердца и разветвляется, чтобы доставлять кислород и
                                                питательные вещества к органам и клеткам всего организма, она очень большая, около 2 см толстая, состоит из эластичной ткани.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=PBV')">
                                    <div class="section03_list--box_on">
                                        <img src="@/assets/resource/img/main/section03_2.png" alt="" />
                                        <h4>
                                            Peripheral<br />
                                            Vascular Center
                                        </h4>
                                        <div class="text">
                                            <h3>Центр периферических сосудов</h3>
                                            <p>
                                                Сосудистая система человека похожа на очень сложную сеть магистралей, которая играет решающую роль в транспортировке крови ко всем частям нашего тела. Нарушение работы этой сети может привести к
                                                изменениям в образе жизни, серьезным заболеваниям и даже опасным для жизни состояниям. Это область заболеваний периферических сосудов, которая включает в себя периферические артерии, вены и лимфу.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=aor')">
                                    <div class="section03_list--box_on">
                                        <img src="@/assets/resource/img/main/section03_3.png" alt="" />
                                        <h4>
                                            Vascular<br />
                                            Health Center
                                        </h4>
                                        <div class="text">
                                            <h3>Центр здоровья сосудов</h3>
                                            <p>
                                                Известно, что метаболические заболевания, вызванные общими нарушениями обмена веществ в нашем организме, повышают риск абдоминального ожирения, высокого кровяного давления, диабета, дислипидемии,
                                                ожирения печени, апноэ во сне и различных видов рака, а также риск сердечно-сосудистых заболеваний в будущем. Если эти нарушения обмена веществ не диагностировать на ранней стадии и не лечить должным
                                                образом, они могут стать страшными заболеваниями, которые из-за осложнений могут привести к смертельным сосудистым заболеваниям.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=DAC')">
                                    <div class="section03_list--box_on">
                                        <img src="@/assets/resource/img/main/section03_4.png" alt="" />
                                        <h4>
                                            Hemodialysis <br />
                                            Vascular Center
                                        </h4>
                                        <div class="text">
                                            <h3>Сосудистый центр диализа</h3>
                                            <p>
                                                Поддержание доступа к диализу для проведения гемодиализа имеет важное значение для поддержания безопасности и здоровья пациентов, получающих гемодиализ. Внезапное сужение и закупорка доступа для диализа
                                                из-за тромбоза может угрожать жизни пациентов, находящихся на гемодиализе, поэтому очень важно постоянное наблюдение и оперативное лечение в случае закупорки.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="swiper-slide section03_list--box" @click="$commonUtils.goMenu('/kr/center?deptCd=MSC')">
                                    <div class="section03_list--box_on">
                                        <img src="@/assets/resource/img/main/section03_5.png" alt="" />
                                        <h4>
                                            Marfan Syndrome/ Hereditary Aortic <br />
                                            Disease Center
                                        </h4>
                                        <div class="text">
                                            <h3>Центр синдрома Марфана и наследственных заболеваний аорты</h3>
                                            <p>
                                                Аневризма грудной аорты (Thoracic aorta aneurysm) – это заболевание, при котором аорта расширяется подобно воздушному шару. Число пациентов в Корее в разбивке по годам составило 1 434 в 2010 г., 2 869 в
                                                2015 г. и 4 192 в 2020 г., удваиваясь каждые пять лет. Проблема в том, что у 20-25% пациентов имеются причины аневризмой грудной аорты по наследственным заболеваниям (Hereditary thoracic aorta
                                                aneurysm). На самом деле, по мере того, как увеличивается число случаев диагностирования заболеваний аорты, увеличивается и число пациентов с наследственными заболеваниями аорты. Например, согласно
                                                данным Службы анализа и оценки медицинского страхования, число пациентов с синдромом Марфана, типичным наследственным заболеванием аорты, растет с каждым годом.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section05">
                <div class="section__title transition02">
                    <h3>Promotional video</h3>
                </div>
                <div class="video transition01">
                    <div class="inner">
                        <div class="video__visual">
                            <iframe src="https://www.youtube.com/embed/QgATczm_n1M" title="World Best, Ewha Womans University Aorta and Vascular Hospital" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                        <ul class="video__list">
                            <li class="video__item">
                                <a href="javascript:;" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon1.png" alt="">
                                        </span>
                                        <span class="text">International Treatment
                                            Guide</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="javascript:;" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon2.png" alt="">
                                        </span>
                                        <span class="text">Reservation Guide</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="javascript:;" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon3.png" alt="">
                                        </span>
                                        <span class="text">Office Hours</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                            <li class="video__item">
                                <a href="javascript:;" class="video__link">
                                    <span class="box">
                                        <span class="icon">
                                            <img src="/resource/icon/video_list_icon4.png" alt="">
                                        </span>
                                        <span class="text">Staff</span>
                                    </span>
                                    <span class="arrow"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

            </section>
        </div>
    </div>
    <firstReservePopUp :popupVisible="firstVisible" :name="name" :tel="tel" @hide-popup="hidePopup"></firstReservePopUp>
    <AlarmTalkPopup :popupVisible="alarmVisible" :name="name" :tel="tel" @hide-popup="hidePopup"></AlarmTalkPopup>
</template>

<script>
    import { gsap } from 'gsap'; // gsap 임포트
    import ScrollTrigger from 'gsap/ScrollTrigger';
    import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
    import 'swiper/swiper-bundle.css'; // Swiper 스타일 추가
    import SlideUpDown from 'vue-slide-up-down';
    Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
    gsap.registerPlugin(ScrollTrigger);

    import { nextTick } from 'vue';
    export default {
        name: 'MainComponent',
        components: {
            SlideUpDown
        },
        data() {
            return {
                firstVisible: false,
                alarmVisible: false,
                name: '',
                tel: '',

                lineCnt: 0,
                lineList: [],
                popupCnt: 0,
                popupList: [],

                mainList: [],
                noticeBoardId: '',
                promotionList: [],
                promotionIdx: 0,

                main_popup: true,
                main_line: false,
                chetbot_select: false,
                popup_chetbot: false,
                section05_list: true,
                section05_list02: false,
                mainHandleScroll: null,

                drSids: '1004540,1005101,1012649,1019621,1019623,1019794',
                doctorList: [],

                mapList: [
                    { src: 'map_B1.jpg', start: 'Выход 8 со станции Бальсан', end: 'Лифт и эскалатор для амбулаторных пациентов' },
                    { src: 'map_3F.jpg', start: 'Get off on the 3rd floor', end: 'Left of the elevator <br> Ewha Womans University Aorta and Vascular Hospital ' }
                ],
                mapIndex: 0,
                mapStartTxt: 'Выход 8 со станции Бальсан'
            };
        },
        mounted() {
            this.getMainBanner();
            this.getMainBoardList();
            // this.getDoctorList();

            // 스크롤 이벤트 리스너 추가
            window.addEventListener('scroll', this.handleScroll);

            function mainScrollFnc() {
                var now = $(window).scrollTop();
                var target01 = $('.section01').offset().top - 112;
                var target02 = $('.section02').offset().top - 600;
                var target03 = $('.section03').offset().top - 600;
                var target05 = $('.section05').offset().top - 600;

                if (now > target01) {
                    $('.section01').addClass('on');
                }
                if (now > target02) {
                    $('.section02').addClass('on');
                }
                if (now > target03) {
                    $('.section03').addClass('on');
                }
                if (now > target05) {
                    $('.section05').addClass('on');
                }
            }

            function mainScrollOffsetFnc() {
                var now = $(window).scrollTop();
                // 화면 크기를 확인하여 모바일인지 데스크탑인지 구분
                var offsetValue = $(window).width() <= 720 ? 170 : 400; // 768px 이하일 경우 모바일로 간주, 오프셋을 100으로 설정
                var targets01 = $('.section01').offset().top + 300;
                var targets02 = $('.section02').offset().top - offsetValue;
                var targets03 = $('.section03').offset().top - offsetValue;
                var targets05 = $('.section05').offset().top - offsetValue;

                if (now > targets01) {
                    $('.section').removeClass('white');
                    $('.section01').addClass('white');
                }
                if (now > targets02) {
                    $('.section').removeClass('white');
                    $('.section02').addClass('white');
                }
                if (now > targets03) {
                    $('.section').removeClass('white');
                    $('.section03').addClass('white');
                }
                if (now > targets05) {
                    $('.section').removeClass('white');
                    $('.section05').addClass('white');
                }
                if (now > targets01) {
                    $('.visual-main__wrap').addClass('on');
                }
            }

            // jQuery 스크롤 이벤트 추가
            this.mainHandleScroll = () => {
                mainScrollFnc();
                mainScrollOffsetFnc();
            };

            window.addEventListener('scroll', this.mainHandleScroll);

            // 화면 크기를 체크하고 1024px 이상인 경우 다른 애니메이션을 적용
            const screenWidth = window.innerWidth

            if (screenWidth >= 1025) {
                // 화면 크기가 1024px 이상일 때 적용할 애니메이션

                setTimeout(() => {
                    $('.section01 .pin-spacer').addClass('on');
                }, 1000);
                const video = document.getElementById('myVideo');
                video.play();

                // gsap 애니메이션 추가
                let visualArea = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.main-visual',
                        pin: '.main-visual',
                        start: 'top top',
                        end: '+=5000',
                        scrub: 1
                    }
                });

                visualArea
                    .addLabel('start')
                    .to('.main-visual__list-type03', { marginTop: '250px', duration: 100 }, 'start')
                    .to('.main-visual__list-type02', { marginTop: '165px', duration: 100, delay: 10 }, 'start')
                    .to('.main-visual__list-type01', { marginTop: '260px', duration: 140, delay: 15 }, 'start')
                    .to('.main-visual__title', { opacity: 0, duration: 80 }, 'start')
                    .to('.main-visual__title', { display: 'none' })
                    .addLabel('start2')
                    .to('.main-visual__list-type03', { height: 'calc(100dvh - 88px)', borderRadius: '0', marginTop: 0, duration: 300 }, 'start2')
                    .to('.imgBlockMain', { height: 'calc(100dvh - 88px)', duration: 300 }, 'start2')
                    .to('.circle01', { opacity: '0', duration: 300 }, 'start2')
                    .addLabel('start3')
                    .to('.imgBlockMain', { width: '100dvw', borderRadius: 0, duration: 400 }, 'start3')
                    .to('.imgBlockMain', { duration: 400 })
                    .to('.imgBlockMain > h3', { opacity: 0, duration: 0 })
                    .to('.visual-main__wrap', { opacity: '1', duration: 400 })
                    .addLabel('start4')
                    .to('.visual-main', { opacity: '1', duration: 400 }, 'start4')
                    .to('.visual-main h3', { fontSize: '120px', opacity: '1', duration: 800 }, 'start4')
                    .to('.visual-main h4', { opacity: '1', duration: 500 })
                    .addLabel('start5')
                    .to('.visual-main__con', { height: '340px', duration: 600 }, 'start5')
                    .to('.visual-main_back', { opacity: '1', duration: 600 }, 'start5')
                    .to('.chetbot', { opacity: '1', pointerEvents: 'initial', duration: 600 }, 'start5')
                    .addLabel('end')
                    .to('.imgBlockMain', { delay: 300 }, 'end');
            } else {
                $('body').addClass('on');
                setTimeout(() => {
                    $('.section01.pin-spacer').addClass('on');
                }, 6000);
                setTimeout(() => {
                    $('body').removeClass('on');
                }, 7000);
                setTimeout(function () {
                    const video = document.getElementById('myVideo');
                    if (video) {
                        video.play(); // 7초 후 영상 재생
                    }
                }, 7000);
            }
            gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.section02', start: 'top bottom', end: '-100%', scrub: true }, bottom: '0' });
            gsap.to('.footer__center-list', { scrollTrigger: { trigger: '.footer', start: 'top bottom', scrub: true, toggleClass: { targets: '.footer__center-list', className: 'on' } } });
        },
        beforeDestroy() {
            // 컴포넌트 파괴 시 Swiper 인스턴스를 정리 (메모리 누수 방지)
            if (this.swiperMain) this.swiperMain.destroy();
            if (this.swiper3_2) this.swiper3_2.destroy();
            if (this.swiper3) this.swiper3.destroy();
            if (this.swiper3_3) this.swiper3_3.destroy();

            // 컴포넌트가 파괴될 때 이벤트 리스너 제거
            window.removeEventListener('scroll', this.handleScroll);
        },
        beforeUnmount() {
            window.removeEventListener('scroll', this.mainHandleScroll)
        },
        methods: {
            setMapList(start) {
                this.mapIndex = 0;
                this.mapList = [];
                if (start == 'B1') {
                    this.mapStartTxt = 'Выход 8 со станции Бальсан';
                    const obj = { src: 'map_B1.jpg', start: 'Выход 8 со станции Бальсан', end: 'Лифт и эскалатор для амбулаторных пациентов' };
                    this.mapList.push(obj);
                } else if (start == 'main') {
                    this.mapStartTxt = 'Главный вход в госпиталь (главные ворота)';
                    const obj = { src: 'map_1F_maingate.jpg', start: 'Главный вход в госпиталь (главные ворота)', end: 'Лифт и эскалатор для амбулаторных пациентов' };
                    this.mapList.push(obj);
                } else if (start == 'north') {
                    this.mapStartTxt = 'Дополнительный вход в госпиталь (северные ворота)';
                    const obj = { src: 'map_1F_northgate02.jpg', start: 'Дополнительный вход в госпиталь (северные ворота)', end: 'Лифт и эскалатор для амбулаторных пациентов' };
                    this.mapList.push(obj);
                } else if (start == 'parking') {
                    this.mapStartTxt = 'Подземная парковка B3-B5';
                    const obj = { src: 'map_parkingGarage.jpg', start: 'Подземная парковка B3-B5', end: 'Лифт и эскалатор для амбулаторных пациентов<br>((Parking location: F, G, H, I))' };
                    this.mapList.push(obj);
                }
                const obj = { src: 'map_3F.jpg', start: 'Get off on the 3rd floor', end: 'Left of the elevator<br>Ewha Womans University Aorta and Vascular Hospital ' };
                this.mapList.push(obj);
            },
            getDoctorList() {
                const param = {
                    startIndex: 1,
                    drName: this.drName,
                    pageRow: 100,
                    langCd: this.$store.getters.getLang,
                    hospId: this.$store.getters.getHost,
                    drSids: this.drSids
                };
                this.axios.get(this.api.doctor.doctorList, { params: param }).then(res => {
                    const arr = res.data.doctorList;
                    this.doctorList = this.$commonUtils.distinctList(arr, 'name');

                    if (arr && arr.length > 0) {
                        const item = this.doctorList[2];
                        this.doctorList[2] = this.doctorList[1];
                        this.doctorList[1] = item;
                    }

                    nextTick(() => {
                        // 모바일 swiper
                        const screenWidth = window.innerWidth;
                        if (screenWidth <= 720) {
                            this.swiper2_2 = new Swiper('.section02-swiper2', {
                                slidesPerView: 1,
                                spaceBetween: 40,
                                slidesPerGroup: 1,
                                initialSlide: 2
                            });
                        }
                        // 의료진 소개 이벤트
                        $('.section02__list .section02__list--aa .section02__list--item').click(function (event) {
                            event.preventDefault(); // 링크의 기본 동작 방지
                            var index = $(this).parent().index(); // 클릭한 링크의 부모 div 요소의 인덱스 가져오기
                            $('.section02_bottom_title div').removeClass('on'); // 모든 p 요소에서 'on' 클래스 제거
                            $('.section02_bottom_title div').eq(index).addClass('on'); // 해당 인덱스에 맞는 p 요소에 'on' 클래스 추가
                        });
                        $('.section02__list a').click(function () {
                            var classes = $(this).attr('class').split(' ');
                            if (!$(this).hasClass('doctor03')) {
                                $('.doctor03').addClass(classes);
                                $('.doctor03').removeClass('doctor03');
                                $(this).removeClass(classes);
                                $(this).addClass('doctor03 cursor section02__list--item');
                            } else {
                                const drSid = $(this).data('drsid');
                                const deptCd = $(this).data('deptcd');
                                location.href = `/kr/doctorInfo?drSid=${drSid}&deptCd=${deptCd}`;
                            }
                        });
                    });
                });
            },
            chatbotOpen() {
                const w = 450;
                const h = 550;
                let xPos = document.body.offsetWidth / 2 - w / 2;
                xPos += window.screenLeft; // 듀얼 모니터일 때
                const yPos = document.body.offsetHeight / 2 - h / 2;

                window.open('https://pf.kakao.com/_xdvyYT/chat?bot=true', 'chatbot', `width=${w}, height=${h}, left=${xPos}, top=${yPos}, menubar=yes, status=yes, titlebar=yes, resizable=yes`);
            },
            getMainBoardList() {
                const param = {
                    pageRow: 6
                };
                this.axios
                    .get(this.api.article.main, {
                        params: param
                    })
                    .then(res => {
                        const list = res.data;
                        if (list) {
                            this.noticeBoardId = list['notice'][0].boardId;
                            this.mainList = list['all'];
                            this.$commonUtils.objArrSort(this.mainList, 'createdDt', 'DESC');
                        }
                        this.promotionList = list['promotion'].slice(0, 2);
                    });
            },
            showPopup(param) {
                if (!this.name || !this.tel) {
                    alert('성함과 휴대전화번호를 입력해주세요.');
                    return;
                }
                this[param] = true;
            },
            hidePopup(param) {
                this[param] = false;
                this.name = '';
                this.tel = '';
            },
            getMainBanner() {
                const param = {
                    hospId: this.$store.getters.getHost
                };
                this.axios
                    .get(this.api.banner.main, {
                        params: param
                    })
                    .then(res => {
                        // 팝업
                        const popup = res.data.popup;
                        this.popupCnt = popup.totCnt;
                        this.popupList = popup.list;

                        if (this.popupCnt > 0) {
                            this.main_popup = true;

                            const oneDay = 24 * 60 * 60 * 1000;
                            const now = new Date().getTime();

                            const popupLastVisit = localStorage.getItem('popupTime');
                            const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null;
                            const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null;

                            if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                                this.main_popup = false;
                            }

                            // Swiper 초기화
                            nextTick(() => {
                                this.initSwipers();
                            });
                        } else {
                            this.main_popup = false;
                        }
                    });
            },
            closePopup() {
                this.main_popup = false;
                const now = new Date().getTime();
                localStorage.setItem('popupTime', now.toString());
            },
            main_popup_close() {
                this.main_popup = false;
            },
            popup_chetbot_active() {
                this.popup_chetbot = !this.popup_chetbot;
            },
            activechetbot_select() {
                this.chetbot_select = !this.chetbot_select;
            },
            section05_list_active() {
                this.section05_list = true;
                this.section05_list02 = false;
            },
            section05_list02_active() {
                this.section05_list02 = true;
                this.section05_list = false;
            },
            handleScroll() {
                var scrollPosition = window.scrollY;

                // 요소가 존재하는지 확인한 후, 클래스를 추가/제거합니다.
                const bottomElement = document.querySelector('.header');
                if (bottomElement) {
                    if (scrollPosition >= 48) {
                        bottomElement.classList.add('on');
                    } else {
                        bottomElement.classList.remove('on');
                    }
                }
            },

            initSwipers() {
                this.main_popup_swiper = new Swiper('.main-popup-swiper', {
                    slidesPerView: 1,
                    loop: true,
                    speed: 600,
                    spaceBetween: 40,
                    breakpoints: {
                        // 720 이상일 때
                        720: {
                            slidesPerView: 2
                        },
                        // 1312 이상일 때
                        1312: {
                            slidesPerView: 3
                        }
                    }
                });
                document.querySelector('.main-popup-swiper__button.next').addEventListener('click', () => {
                    if (this.main_popup_swiper) {
                        this.main_popup_swiper.slideNext();
                    }
                });

                document.querySelector('.main-popup-swiper__button.prev').addEventListener('click', () => {
                    if (this.main_popup_swiper) {
                        this.main_popup_swiper.slidePrev();
                    }
                });

                // 메인 슬라이드
                this.swiperMain = new Swiper('.main-visual__slide', {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: true,
                    autoplay: {
                        delay: 3000
                    },
                    speed: 600
                });

                // section03_list2 슬라이드
                this.swiper3_2 = new Swiper('.section03_list2', {
                    slidesPerView: 1, // 한 번에 보여줄 슬라이드 수
                    touchRatio: 0.4, // 터치 비율 (슬라이드 조작 반응도)
                    loop: true, // 루프 설정
                    spaceBetween: 0,
                    autoplay: {
                        delay: 4000, // 자동 전환 시간 (4초)
                        disableOnInteraction: false // 상호작용 후 자동 전환 유지
                    },
                    speed: 300, // 전환 속도 (1초)
                    fadeEffect: {
                        crossFade: true // 교차 페이드 효과를 활성화 (슬라이드가 겹쳐서 전환)
                    },
                    navigation: {
                        nextEl: '.section03_list2-button-next',
                        prevEl: '.section03_list2-button-prev'
                    },
                    breakpoints: {
                        // 1024 이상일 때
                        720: {
                            speed: 1000
                        }
                    }
                });

                // section03_list 슬라이드
                this.swiper3 = new Swiper('.section03_list', {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 150,
                    loop: true,
                    speed: 1000
                });

                // section03_list-back 슬라이드
                this.swiper3_3 = new Swiper('.section03_list-back', {
                    slidesPerView: 1,
                    loop: true,
                    speed: 0
                });

                document.querySelector('.section03_list2-button-next').addEventListener('click', () => {
                    if (this.swiper3_2) {
                        this.swiper3_2.slideNext();
                    }
                });

                document.querySelector('.section03_list2-button-prev').addEventListener('click', () => {
                    if (this.swiper3_2) {
                        this.swiper3_2.slidePrev();
                    }
                });

                // swiper3_2가 스와이프될 때 swiper3도 같은 방향으로 스와이프
                this.swiper3_2.on('slideNextTransitionStart', () => {
                    this.swiper3.slidePrev();
                    this.swiper3_3.slideNext();
                    this.toggleWarpClass();
                });

                this.swiper3_2.on('slidePrevTransitionStart', () => {
                    this.swiper3.slideNext();
                    this.swiper3_3.slidePrev();
                    this.toggleWarpClass();
                });

                // section06_list 슬라이드
                this.swiper = new Swiper('.section06_list', {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    loop: true,
                    breakpoints: {
                        // 1024 이상일 때
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40 // 간격을 30으로 변경
                        }
                    }
                });
                const screenWidth = window.innerWidth;
                if (screenWidth <= 720) {
                    this.swiper2 = new Swiper('.section02-swiper', {
                        slidesPerView: 1,
                        spaceBetween: 40,
                        slidesPerGroup: 1,
                        initialSlide: 2
                    });
                    // setTimeout(() => {
                    //     this.swiper2_2 = new Swiper('.section02-swiper2', {
                    //         slidesPerView: 1,
                    //         spaceBetween: 40,
                    //         slidesPerGroup: 1,
                    //         initialSlide: 2,
                    //     });
                    // }, 4000);
                    this.swiper2.on('slideNextTransitionStart', () => {
                        this.swiper2_2.slideNext();
                    });

                    this.swiper2.on('slidePrevTransitionStart', () => {
                        this.swiper2_2.slidePrev();
                    });
                    document.querySelector('.section02-swiper-button-next').addEventListener('click', () => {
                        if (this.swiper2) {
                            this.swiper2.slideNext();
                            this.toggleWarpClass02();
                        }
                    });

                    document.querySelector('.section02-swiper-button-prev').addEventListener('click', () => {
                        if (this.swiper2) {
                            this.swiper2.slidePrev();
                            this.toggleWarpClass02();
                        }
                    });

                    // Intersection Observer API 설정
                    const sections = document.querySelectorAll('.section');

                    // 옵저버 콜백 함수: 섹션이 화면에 보일 때 'active' 클래스를 추가
                    const observerOptions = {
                        threshold: 0.5 // 50% 이상 보일 때 트리거
                    };

                    const observerCallback = (entries, observer) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                // 섹션이 화면에 보이면 'active' 클래스 추가
                                entry.target.classList.add('active');

                                // GSAP을 사용한 애니메이션: 섹션이 보일 때 투명도와 배경색을 변경
                                gsap.to(entry.target, {
                                    opacity: 1,
                                    duration: 1, // 1초 동안 서서히 나타나게
                                    ease: 'power3.out' // 애니메이션 효과
                                });
                            } else {
                                // 섹션이 화면에서 벗어나면 'active' 클래스 제거
                                entry.target.classList.remove('active');
                            }
                        });
                    };

                    const observer = new IntersectionObserver(observerCallback, observerOptions);

                    // 모든 섹션에 대해 Intersection Observer 적용
                    sections.forEach(section => {
                        observer.observe(section);
                    });
                }


            },
            toggleWarpClass() {
                const screenWidth = window.innerWidth;
                if (screenWidth <= 720) {
                    const warp = document.querySelector('.section03_list2_warp');
                    if (warp) {
                        warp.classList.add('on');
                        setTimeout(() => {
                            warp.classList.remove('on');
                        }, 300);
                    }
                } else {
                    const warp = document.querySelector('.section03_list2_warp');
                    if (warp) {
                        warp.classList.add('on');
                        setTimeout(() => {
                            warp.classList.remove('on');
                        }, 1000);
                    }
                }
            },
            toggleWarpClass02() {
                const warp = document.querySelector('.section02');
                if (warp) {
                    warp.classList.add('active');
                    setTimeout(() => {
                        warp.classList.remove('active');
                    }, 300);
                }
            }
        }
    };
</script>
<style scoped></style>